import isDate from 'lodash/isDate';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import transform from 'lodash/transform';

export type CleanDeep<T> = T extends (infer U)[]
  ? CleanDeep<U>[]
  : T extends object
    ? { [K in keyof T]?: CleanDeep<T[K]> }
    : NonNullable<T>;

export const cleanDeep = <T extends object>(obj: T): CleanDeep<T> =>
  transform<T, CleanDeep<T>>(obj, (result, value, key) => {
    const typedKey = key as keyof CleanDeep<T>;
    // if the value is an object (and not null), recurse deep
    if (isObject(value) && !isDate(value)) {
      const cleaned = cleanDeep(value);

      // remove empty objects
      if (isEmpty(cleaned)) {
        return;
      }
      result[typedKey] = cleaned as CleanDeep<T>[keyof CleanDeep<T>];
    }

    // if the value is not null/undefined, keep it
    if (!isNil(value)) {
      result[typedKey] = value as unknown as CleanDeep<T>[keyof CleanDeep<T>];
    }
  }) as CleanDeep<T>;
